import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TaxsDetailsComponent } from './taxs-details.component';

const routes: Routes = [{ path: '', component: TaxsDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TaxDetailsRoutingModule { }


